<template>
  <Default class="view-contacts">
    <div class="container">
      <FormLogin />
    </div>
  </Default>
</template>
<script setup>
import Default from "@/layouts/Default.vue";
import FormLogin from "@/components/form/FormLogin.vue";
import { onMounted } from "vue";
import { setLanguageParameter } from "@/composables/language.js";

onMounted(() => {
  setLanguageParameter();
});
</script>
